import { Link } from "react-router-dom";

// Existing relationships only: each tool's own category hub and the published guides it belongs
// with. No new content, no affiliate links.
const RELATED = {
  "golf-simulator-room-fit": {
    hub: { to: "/hub/recreation", label: "Golf Simulators" },
    guides: [
      { to: "/guides/will-a-golf-simulator-fit-in-my-garage",
        label: "Will a golf simulator fit in my garage?" },
      { to: "/guides/how-much-does-a-complete-golf-simulator-really-cost",
        label: "How much does a complete golf simulator really cost?" },
    ],
  },
  "generator-coverage-estimator": {
    hub: { to: "/hub/home-power-technology", label: "Home Power & Technology" },
    guides: [
      { to: "/guides/what-size-generator-do-i-actually-need",
        label: "What size generator do I actually need?" },
      { to: "/guides/what-should-i-actually-power-during-an-outage",
        label: "What should I actually power during an outage?" },
      { to: "/guides/generator-vs-battery-backup",
        label: "Generator or battery backup: which suits your home?" },
    ],
  },
};

export const ToolRelated = ({ slug }) => {
  const rel = RELATED[slug];
  if (!rel) return null;
  return (
    <section
      data-testid={`tool-related-${slug}`}
      className="max-w-[900px] mx-auto px-5 md:px-8 mt-16 pt-10 border-t border-line"
    >
      <span className="eyebrow">Read next</span>
      <ul className="mt-5 space-y-3">
        {rel.guides.map((g) => (
          <li key={g.to}>
            <Link
              to={g.to}
              data-testid={`tool-related-guide-${g.to.split("/").pop()}`}
              className="text-[16px] leading-snug text-[#48563F] font-medium hover:text-sage-dark transition-colors"
            >
              {g.label}
            </Link>
          </li>
        ))}
      </ul>
      <p className="text-[14.5px] text-[#5E5A54] mt-5">
        Or browse every decision in{" "}
        <Link
          to={rel.hub.to}
          data-testid={`tool-related-hub-${slug}`}
          className="text-[#48563F] font-medium underline decoration-sage/50 underline-offset-2 hover:text-sage-dark transition-colors"
        >
          {rel.hub.label}
        </Link>
        .
      </p>
    </section>
  );
};

// The reverse direction: a guide points at the tool that continues the same decision.
const GUIDE_TOOL = {
  "will-a-golf-simulator-fit-in-my-garage": {
    to: "/tools/golf-simulator-room-fit",
    label: "Golf Simulator Room Fit Checker",
    line: "Measure your own space against these clearances with the",
  },
  "how-much-does-a-complete-golf-simulator-really-cost": {
    to: "/tools/golf-simulator-room-fit",
    label: "Golf Simulator Room Fit Checker",
    line: "See what configuration your room actually supports with the",
  },
  "what-size-generator-do-i-actually-need": {
    to: "/tools/generator-coverage-estimator",
    label: "Generator Coverage Estimator",
    line: "Work out your own load list with the",
  },
  "what-should-i-actually-power-during-an-outage": {
    to: "/tools/generator-coverage-estimator",
    label: "Generator Coverage Estimator",
    line: "Turn your priorities into a coverage figure with the",
  },
  "generator-vs-battery-backup": {
    to: "/tools/generator-coverage-estimator",
    label: "Generator Coverage Estimator",
    line: "Size the option you choose with the",
  },
};

export const GuideToolLink = ({ slug }) => {
  const t = GUIDE_TOOL[slug];
  if (!t) return null;
  return (
    <p
      data-testid={`guide-tool-link-${slug}`}
      className="text-[15.5px] leading-relaxed text-[#4F4B45] mt-8 border-l-2 border-sage/50 pl-4 max-w-3xl"
    >
      {t.line}{" "}
      <Link
        to={t.to}
        data-testid={`guide-tool-anchor-${slug}`}
        className="text-[#48563F] font-medium underline decoration-sage/50 underline-offset-2 hover:text-sage-dark transition-colors"
      >
        {t.label}
      </Link>
      .
    </p>
  );
};
